import { useQueryClient } from '@tanstack/react-query';
import { type VideoContentObject, type VideoStatus, createVideoContentObject } from 'models';
import { useMutation } from 'query';
import { updateStatus } from '../../services';
import { getVideoDetailQueryKey, getVideosQueryKey } from '../keys';

export const useUpdateStatus = () => {
  const queryClient = useQueryClient();

  return useMutation<VideoContentObject, { id: string; video: { status: VideoStatus } }>({
    async mutationFn({ id, video }) {
      const response = await updateStatus({
        data: { video },
        id,
      });

      return createVideoContentObject(response.data);
    },
    async onSuccess({ video }) {
      await queryClient.invalidateQueries({ queryKey: getVideoDetailQueryKey({ videoId: video.id }) });
      await queryClient.invalidateQueries({ queryKey: getVideosQueryKey({}) });
    },
  });
};
